import { DateTime } from "luxon";
import { useMemo } from "react";
import { getEndOfMonthIso, getEndOfQuarterIso } from "util/dates";
import { PickersShortcutsItem } from "@mui/x-date-pickers";

/**
 * Hook to generate shortcuts for end date picker based on measurement date.
 * Returns shortcuts for "End of month" and "End of quarter" if a measurement date is provided.
 */
export function useEndDateShortcuts(
  measuredAtUtc: string | null | undefined
): PickersShortcutsItem<DateTime>[] {
  return useMemo(() => {
    if (!measuredAtUtc) return [];
    const monthEnd = getEndOfMonthIso(measuredAtUtc);
    const quarterEnd = getEndOfQuarterIso(measuredAtUtc);
    const items: PickersShortcutsItem<DateTime>[] = [];
    if (monthEnd) {
      items.push({
        label: "End of month",
        getValue: () => DateTime.fromISO(monthEnd),
      });
    }
    if (quarterEnd) {
      items.push({
        label: "End of quarter",
        getValue: () => DateTime.fromISO(quarterEnd),
      });
    }
    return items;
  }, [measuredAtUtc]);
}
